import { trimObj } from "../components/Utils";

export const consultarNodos = (filtros, paginationMode) => ({
    url: `admin/nodos`,
    method: 'GET',
    params: {
        ...filtros,
        page: paginationMode.page,
        size: paginationMode.pageSize,
    }
})

export const consultarNodosDisponibles = () => ({
    url: `admin/nodos/disponibles`,
    method: 'GET',
})

export const registrarNodo = (data) => ({
    url: `admin/nodos`,
    method: 'POST',
    data: {
        ...trimObj(data)
    }
})

export const consultarNodo = (nodoId) => ({
    url: `admin/nodos/${nodoId}`,
    method: 'GET',
})

export const actualizarNodo = (nodoId, data) => ({
    url: `admin/nodos/${nodoId}`,
    method: 'PUT',
    data: {
        ...data
    }
})
